<!-- 在线用户集合 -->
<template>
  <div class="online-user-list">
    <div class="online-user-list-header" style="display: none">

      <div class="online-user-list-header-prompt">
        <!--                点击在线学生头像可与该学生互动-->
      </div>
<!--      <div class="online-user-list-header-tool">-->
<!--        <div-->
<!--            class="online-user-list-header-tool-item"-->
<!--            v-for="item of headerToolList" :key="item.key"-->
<!--            @click="item.clickM">-->
<!--          <div></div>-->
<!--          <div> {{ item.name }}</div>-->

<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="online-user-list-body" v-if="onlineUserList && onlineUserList.length>0">
        <online-user-video
            v-for="item of onlineUserList"
            :key="item.userId"
            :user-info="item"
        ></online-user-video>
    </div>
    <div class="online-user-list-default" v-else>
      <img src="../../assets/images/video-error.png" alt="暂无数据"/>
      <p>暂无在线用户</p>
    </div>
  </div>
</template>

<script>
import RTCClient from "../../rtc/RTCClient";
import StudentService from "../../services/student.service";
import {RTCUserMark} from "../../ts/Enum";
export default {
  name: "OnlineUserListComponent",
  props: {
    /**
     * 活动所在的班级ID
     */
    gardenId: {
      type: String,
      default: ''
    },
    /**
     * 活动所在的班级ID
     */
    classId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 在线用户列表，包含用户的ID、显示名称、是否可以展示视频等信息
      onlineUserList: [],
      // 班级同学列表
      classStudentList: [],
      // 用户总人数（需要上线的本班学生人数+已经上线的非本班和未登录人员）
      userTotalCount: 0,
      // 当前在线人数
      userOnlineCount: 0,
    }
  },
  watch: {
    classId: {
      deep: true,
      handler(nv) {
        if (!nv) {
          return;
        }
        this.getClassStudents()
      }
    },
    userTotalCount:{
      deep: true,
      handler(nv) {
        this.$emit('userTotalCountChange', nv)
      }
    },
    userOnlineCount:{
      deep: true,
      handler(nv) {
        this.$emit('userOnlineCountChange', nv)
      }
    }
  },
  created() {
    this.getClassStudents()
  },
  mounted() {
  },
  methods: {
    /**
     * 获取班级下的学生
     */
    getClassStudents() {
      if (!this.classId || !this.gardenId) {
        this.classStudentList = []
        return
      }
      StudentService.getClassStudents({
        gardenId: this.gardenId,
        classId: this.classId,
      }).then((res) => {
        if (res) {
          this.classStudentList = res
        } else {
          this.classStudentList = []
        }
        this.userTotalCount = this.classStudentList.length

      }).catch(err => {
        console.log(err)
      })
    },

    /**
     * 用户上线
     * @param {*} user 上线的用户信息（经过过滤，不是教师用户也不是当前用户的其他用户上线）
     */
    userOnline(user) {
      const index = this.onlineUserList.findIndex(item => item.userId === user.userId)
      if (index === -1) {
        // 用户姓名的后缀信息
        let identitySuffix = '本班'
        // 用户Id以'X_'为前缀开头的，为非登录人员
        if (user.userId.startsWith(RTCUserMark.notLoggedIn.toString())) {
          identitySuffix = '非登录人员'
        } else if (user.userId.startsWith(RTCUserMark.teacher.toString())){
          // 教师用户的身份前缀为非本班
          identitySuffix = '非本班'
        } else {
          // 学生根据本班学生列表，判断是否是本班学生
          if (!this.classStudentList || this.classStudentList.length <=0) {
            identitySuffix = '非本班'
          } else {
            const index = this.classStudentList.findIndex(item => {
              return user.userId.startsWith(`${RTCUserMark.student}${item.id}_`)
            })
            identitySuffix = index < 0 ? '非本班' : '本班'
          }
        }
        const onlineUser = {
          userId: user.userId,
          displayName: user.displayName,
          showVideo: false,
          videoDefaultText: '用户未推流',
          identitySuffix: identitySuffix,
          pictureCount: 1
        }
        this.onlineUserList.unshift(onlineUser)
        // 在线人数 + 1
        this.userOnlineCount++
        // 非本班学生时，总人数也要+1
        if (onlineUser.identitySuffix != '本班') {
          this.userTotalCount++
        }
      }
    },

    /**
     * 用户下线
     * @param {*} user 下线的用户信息（经过过滤，不是教师用户也不是当前用户的其他用户上线）
     */
    userOffline(user) {
      const index = this.onlineUserList.findIndex(item => item.userId === user.userId)
      if (index > -1) {
        let offlineUser = this.onlineUserList[index]
        this.onlineUserList.splice(index, 1)
         // 在线人数 - 1
        this.userOnlineCount--
        // 非本班学生时，总人数也要+1
        if (offlineUser.identitySuffix != '本班') {
          this.userTotalCount--
        }
      }
    },

    /**
     * 用户的推流状态更改
     * @param publisher 用户推流的信息
     */
    userPublishChange(publisher) {
      let userId = publisher.userId
      // 从在线用户集合中找到该用户
      const index = this.onlineUserList.findIndex(item => item.userId === userId)
      if (index === -1) {
        return
      }
      let streamConfigs = publisher.streamConfigs.filter(item => item.state === 'active')
      let _this = this
      // 订阅具体的流数据
      RTCClient.instance
          .setSubscribeStream(publisher.userId, streamConfigs)
          .then((result) => {
            _this.onlineUserList[index].pictureCount = result.pictureCount
            if (result.pictureCount === 0) {
              _this.onlineUserList[index].showVideo = false
              _this.onlineUserList[index].videoDefaultText = '用户停止推送视频流'
            } else {
              // 定义主画面和浮动画面ID变量
              const mainPictureVideoId = publisher.userId + '-main-picture'
              const floatingPictureVideoId = publisher.userId + '-floating-picture'

              _this.onlineUserList[index].showVideo = true
              if (result.pictureCount > 1) {
                this.displayRemoteVideo(publisher.userId, mainPictureVideoId, 2)
                this.displayRemoteVideo(publisher.userId, floatingPictureVideoId, 1)
              } else {
                if (result.mainPictureType === 2) {
                  this.displayRemoteVideo(publisher.userId, mainPictureVideoId, 2)
                } else {
                  this.displayRemoteVideo(publisher.userId, mainPictureVideoId, 1)
                }
              }
            }
          }).catch((reject) => {
            _this.onlineUserList[index].showVideo = false
            _this.onlineUserList[index].pictureCount = 0
            // 如果存在订阅失败异常信息，吐司提示为何订阅失败，并且教师视频预览区域展示缺省文案
            if (reject.result.pictureCount === 0) {
              // 如果没有订阅失败异常信息，但是进入了错误回调，那么代表当前没有活跃的视频流，教师视频预览区域展示缺省文案
              _this.onlineUserList[index].videoDefaultText = '用户停止推送视频流'
            } else {
              if (reject.error.errorCode === 10500) {
                this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
              } else {
                this.$message('订阅用户'+_this.onlineUserList[index].displayName+'分享的视频时出现异常！')
              }
              _this.onlineUserList[index].videoDefaultText = '订阅用户分享视频异常'
            }
          });

    },

    /**
     * 展示远端视频
     * @param publisherId 推流用户ID
     * @param videoEleId  视频标签ID
     * @param videoStreamType 流类型。 1：摄像头流，2：屏幕分享流
     */
    displayRemoteVideo(publisherId, videoEleId, videoStreamType) {
      // 下次 DOM 更新循环结束之后执行延迟回调。当前即video标签渲染成功后再执行后续步骤
      this.$nextTick(() => {
        // 找到video标签
        let videoEle = document.getElementById(videoEleId)
        RTCClient.instance.setDisplayRemoteVideo(
          publisherId,
          videoEle,
          videoStreamType
        )
      })
    }


  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index";

.online-user-list {
  height: calc(100% - #{computer(60px)});
  width: 100%;

  &-header {
    margin: 10px;
    display: flex;
    justify-content: space-between;

    &-prompt {
      color: #999999;
      font-size: 14px;
    }

    &-tool {
      display: flex;
      margin-right: 20px;

      &-item {
        @include cursor-pointer();
        padding: 0 computer(10px);
      }
    }
  }


  &-body {
    margin-top: computer(5px);
    height: 100%;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    overflow-y: scroll;
    @include scroll-bar(5px);

    .online-user-video {
      width: 30%;
      height: computer(200px);
    }
  }

  &-default {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: computer(14px);
    position: relative;

    img {
      display: block;
      width: 25%;
    }

    p {
      font-size: computer(12px);
      color: #666666;
      margin-top: computer(5px);
    }
  }
}
</style>
